import Ajax from './ajax';
import Manba from 'manba';

const Request = {
  Arquivo: {
    // downloadVendas: (ids) => Ajax.getBlob(`/v1/arquivo/download-vendas/${ids.join(',')}`),
    exportar: (search) => Ajax.get(`v1/arquivo/solicitarListaArquivosVenda`, search),
    downloadSelecionados: (ids) => Ajax.postJson(`v1/arquivo/solicitarArquivosVenda`, { ids: ids.join(',') }),
    getSelect: () => Ajax.get('/v1/arquivo/select'),
    getAll: (search) => {
      let params = Object.assign({}, search || {});

      if (params.date === '' || params.date === null) {
        delete params.date;
      }

      if (params.date !== undefined) {
        params.date = Manba(params.date, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }

      if (params.status === '' || params.status === null) {
        delete params.status;
      }

      if (params.tipo === '' || params.tipo === null) {
        delete params.tipo;
      }

      return Ajax.get('/v1/arquivo', params);
    },
    get: (id) => Ajax.get(`/v1/arquivo/${id}`),

    total: (search) => Ajax.get(`/v1/arquivo/total`, search),
    lista: (page, search) => Ajax.get(`/v1/arquivo/lista/${page}`, search)
  },
  User: {
    info() {
      return Ajax.get('/account/info');
    },
    checkPassword(pass) {
      return Ajax.post('/v1/user/checkPassword', { password: pass });
    }
  },
  Dict: {
    get() {
      return Ajax.get(`/dict`);
    }
  },
  Home: {
    getMessageList() {
      // return Ajax.get(`/home/messages`);
    }
  },
  SingleSignOn: {
    login(param) {
      return Ajax.postJson('/v1/sso', param);
    }
  },
  Login: {
    login(param) {
      return Ajax.postJson('/v1/login', param);
    },
    logout(param) {
      return Ajax.post('/logout', param);
    }
  },
  Usuario: {
    getTour() {
      return Ajax.get('/v1/user/getTour');
    },
    saveTour() {
      return Ajax.post('/v1/user/saveTour');
    },
    preferencia(userId, jsonPatch) {
      return Ajax.patchJson(`/v2/user/${userId}`, jsonPatch);
    }
  },
  Integracao: {
    chamarServico(id, tipo, params) {
      return Ajax.postJson(`/v1/integracao/controle-execucao/chamar-servico/${tipo}/${id}`, params);
    },
    listarControleExecucao() {
      return Ajax.get(`/v1/integracao/controle-execucao`);
    },
    fxDataExisteAlgumaConfiguracao() {
      return Ajax.head('/v1/integracao/fxdata/existe-alguma-configuracao', null, true);
    },
    saveFxData(dados) {
      return Ajax.postJson('/v1/integracao/fxdata', dados);
    },
    validarFxData(dados) {
      return Ajax.postJson('/v1/integracao/fxdata/validar', dados);
    },
    getOrInsertFinancas360() {
      return Ajax.get('/v1/integracao/pdvfinancas360/getOrInsert');
    },
    savePDVFinancas360(dados) {
      return Ajax.postJson('/v1/integracao/pdvfinancas360', dados);
    },
    chamarServicoPDVFinancas360(params) {
      return Ajax.postJson('/v1/integracao/controle-execucao/chamar-servico/pdvfinancas360/', params);
    },
    get(id) {
      return Ajax.get(`/v1/integracao/${id}`);
    },
    getAll() {
      return Ajax.get(`/v1/integracao`);
    },
    delete(id) {
      return Ajax.delete(`/v1/integracao/${id}`);
    }
  },
  Notificacao: {
    naoLidas() {
      return Ajax.get('/v1/caixa-entrada/nao-lidas/top5');
    },
    getAllMensagens() {
      return Ajax.get('/v1/caixa-entrada');
    },
    arquivar(ids) {
      return Ajax.patchJson('/v1/caixa-entrada/arquivar', ids);
    },
    marcarComoLida(ids) {
      return Ajax.patchJson('/v1/caixa-entrada/marcar-como-lida', ids);
    },
    marcarComoNaoLida(ids) {
      return Ajax.patchJson('/v1/caixa-entrada/marcar-como-nao-lida', ids);
    },
    getMensagem(id) {
      return Ajax.get(`/v1/caixa-entrada/${id}`);
    }
  },
  Empresa: {
    todas() {
      return Ajax.get('/v1/empresas');
    },
    alterar(param, id) {
      return Ajax.patchJson(`v2/empresa/${id}`, param);
    }
  },
  DashBoard: {
    vendas(params) {
      return Ajax.getCustom('/v1/vendas', (params || null));
    },
    vendasErro(params) {
      return Ajax.getCustom('/v1/vendaasdaqw3eqs', (params || null));
    },
    vendasBlob(params) {
      return Ajax.getBlob('/v1/vendas', (params || null));
    },
    empresas() {
      return this.Empresa.todas();
    },
    vendedores() {
      return Ajax.get('/v1/vendedor/lista');
    },
    cards(action, params) {
      return Ajax.get(`/v1/dashboard/cards/${action}`, (params || null));
    },
    existeVendas() {
      return Ajax.get('v1/vendas/existe-vendas');
    },
    painelVendas(params) {
      return Ajax.get(`/v1/vendas/lista/1?${params}`);
    }
  },
  DashBoardEditor: {
    criarUmaNova: (param) => Ajax.postJson(`v2/dashboards`, param),
    listarTodas: () => Ajax.get(`/v2/dashboards/`),
    listarWidGets: () => Ajax.get('v2/dashboardGallery/widgets'),
    listarInformacoes: () => Ajax.get(`/v2/dashboards/true`),
    listarUm: (id) => Ajax.get(`v2/dashboards/${id}`),
    removerUm: (id) => Ajax.delete(`v2/dashboards/${id}`),
    alterar: (param, id) => Ajax.patchJson(`v2/dashboards/${id}`, param),
    AlterarFiltrosCard: (id, param) => Ajax.patchJson(`/v2/dashboardItems/${id}/dashboardItemCardFilter`, param),
    AlterarFiltrosChartLike: (id, param) => Ajax.patchJson(`/v2/dashboardItems/${id}/dashboardItemChartFilter`, param),
    removeFiltro: (id) => Ajax.delete(`/v2/dashboardItems/${id}/dashboardItemFilter`)
  },
  Metas: {
    salvar: (param) => Ajax.postJson(`/v1/metas`, param),
    exportarModelo: (parms) => Ajax.getBlob(`/v1/metas/exportar-modelo${parms}`),
    estagioConfiguracao: (ano) => Ajax.get(`/v1/metas/${ano}/estagio-configuracao`),
    getByEmpresaAnoMes: (empresa, ano, mes) => Ajax.get(`/v1/metas/${empresa}/${ano}/${mes}`),
    getVendedores: (empresa) => Ajax.get(`/v1/metaVendedor/${empresa}/vendedores-ultimo-mes`),
    salvarVendedoresMetas: (empresa, params) => Ajax.postJson(`./v1/MetaVendedor/${empresa}`, params),
    getDiasMetaVendedor: (empresa, params) => Ajax.get(`/v1/MetaVendedor/${empresa}`, params),
    deletarPeriodoMetasVendedor: (empresa, { periodo }) => Ajax.delete(`/v1/MetaVendedor/${empresa}?periodo=${periodo}`),
    salvarNiveisMetaGeral: (NomeNivelMeta, PercentualDeCrescimento, PercentualBoleto1, filtros) => Ajax.postJson('/v1/metas/salvar-modelo', { NomeNivelMeta, PercentualDeCrescimento, PercentualBoleto1, ...filtros }),
    deletarModelos: (idNivelMeta, removerMetasJaCadastradas) => Ajax.delete(`/v1/metas/excluir-modelo?id=${idNivelMeta}&RemoverNiveisDeMeta=${removerMetasJaCadastradas}`),
    listarModelos: () => Ajax.get('/v1/metas/listar-modelos'),
    atualizarModeloDeNivel: ({ _id, nomeNivelMeta, percentualDeCrescimento, percentualBoleto1, ...rest }) => Ajax.postJson('/v1/metas/salvar-modelo', { _id: _id, NomeNivelMeta: nomeNivelMeta, PercentualDeCrescimento: percentualDeCrescimento, PercentualBoleto1: percentualBoleto1, ...rest }),
    listarNiveisMeta: (metaId) => Ajax.get(`/v1/metas/listar-niveis/`, { metaId }),
    removerMeta: (metaId) => Ajax.delete(`/v1/metas/remover-meta?metaId=${metaId}`)
  },
  MetasConfiguracao: {
    salvar: (empresa, diaSemanaLojaFechada, diaSemanaLojaAberta) => Ajax.postJson(`/v1/metas-configuracao/${empresa}`, { diaSemanaLojaFechada: diaSemanaLojaFechada, diaSemanaLojaAberta: diaSemanaLojaAberta }),
    get: (empresa) => Ajax.get(`/v1/metas-configuracao/${empresa}`),
    obterHistorico: (param) => Ajax.postJson(`/v1/metas-configuracao/historico`, param)
  },
  Vendas: {
    total: (search) => Ajax.get(`/v1/vendas/total`, search),
    lista: (page, search) => Ajax.get(`/v1/vendas/lista/${page}`, search),
    vendedores: () => Ajax.get(`/v1/vendedor/lista/`),
    exportar: (search) => Ajax.get(`/v1/vendas/solicitarListaVendas`, search),
    deletarVendas: (idsVendas) => {
      return Ajax.delete(`/v1/vendas`, {
        data: idsVendas
      });
    },
    atualizarVendedores: (params) => Ajax.postJson(`/v1/vendas/alterar-vendedor`, params),
    multiKPI: (params) => Ajax.getBlob(`/v1/vendas/`, params),
    multiKpiJson: (params) => Ajax.get(`/v1/vendas/`, params)
  },
  Regras: {
    salvar: (params) => Ajax.postJson('v1/regras/salvar', params),
    listar: () => Ajax.get('v1/regras/listar'),
    deletar: (id) => Ajax.delete(`v1/regras/remove?Id=${id}`),
    listarUsuarios: () => Ajax.get('v1/regras/listar-usuarios'),
    listarAutorizacoes: () => Ajax.get('v1/regras/listar-autorizacoes')
  },
  Relatorios: {
    exportar: (filtros) => Ajax.get(`v1/vendas/relatorios/exportar-relatorio`, filtros)
  },
  Vendedores: {
    totalVendedores: () => Ajax.get(`/v1/vendedor/total`),
    vendedores: (filters, currentPage) => Ajax.get(`/v1/vendedor/lista/${currentPage}`, { ...filters }),
    deletarVendedores: (ids) => Ajax.delete('/v1/vendedores', { data: ids }),
    editarVendedor: (id, vendedor) => Ajax.post(`/v1/vendedor/${id}`, { ...vendedor }),
    mesclarExcluir: (vendedores) => Ajax.postJson('v1/vendedoresduplicados/unificarVendedores', { ...vendedores })
  },
  Cluster: {
    criarUmCluster: (cluster) => Ajax.postJson('/v2/cluster/', cluster),
    listarTodos: (tipo) => Ajax.get(`/v2/cluster/${tipo || 0}`),
    listarUm: (id) => Ajax.get(`/v2/cluster/${id}`),
    editarUmGrupo: (parms, id) => Ajax.patchJson(`/v2/cluster/${id}`, parms),
    excluirUm: (id) => Ajax.delete(`/v2/cluster/${id}`)
  },
  Campanhas: {
    clickLandingPageFX() {
      return Ajax.postJson('/v1/campanha/clickLandingPageFX', { url: window.location.href });
    }
  },
  Enum: {
    /*
      Lista de enums disponíveis
      "local-empresa"
      "marcas"
      "status-arquivo"
      "tipo-boleto"
      "tipo-documento"
      "tipo-documento-importado"
      "tipo-empresa"
      "tipo-relatorio"
      "indicadores"
      "situacoes-venda"
      "telas-plataforma"
      "funcionalidades-tela"
      "tipo-valor"
    */
    getEnum: (name, call) => Ajax.get(`/v1/enum/${name}`)
  },
  Public: {
    DownloadVendasStorage(params) {
      return Ajax.getBlob('/v1/vendas/downloadVendasStorage/', params);
    },
    DownloadListaArquivosStorage(params) {
      return Ajax.getBlob('/v1/arquivo/downloadListaArquivosStorage/', params);
    },
    DownloadArquivosVendaStorage(params) { // selecionados
      return Ajax.getBlob('/v1/arquivo/downloadArquivosVendaStorage/', params);
    },
    DownloadRelatorio(params) {
      return Ajax.getBlob('/v1/vendas/relatorios/download-relatorio', params);
    }
  },
  Chat: {
    zendeskToken() {
      return Ajax.get('v1/zendesk');
    }
  },
  Configs: {
    listarTodos: () => Ajax.get('v2/configuration'),
    atualizar: (parms, id) => Ajax.patchJson(`v2/configuration?configurationId=${id}`, parms)
  }
};

// rotas que deve ser disponibilizadas apenas em modo desenv
if (process.env.NODE_ENV === 'development') {
  Request.Dev = {
    login: (cliente, usuario) => Ajax.get(`/v1/dev/login?clienteId=${cliente}&userId=${usuario}`)
  };
}

export default Request;
